import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
// @ts-ignore - constants is a JS file without type definitions
import { REFERRAL_FAQS } from "constants";

import "./FAQ.scss";

function FAQ() {
  const [expandedFAQ, setExpandedFAQ] = useState<string | null>(REFERRAL_FAQS[0]?.question || null);

  const handleFAQClick = (question: string) => {
    setExpandedFAQ(expandedFAQ === question ? null : question);
  };

  return (
    <div className="faq-section">
      <h2 className="section-title">Frequently asked questions</h2>
      <div className="faq-list">
        {REFERRAL_FAQS.map((faq) => (
          <div
            key={faq.question}
            className={`faq-item ${expandedFAQ === faq.question ? "expanded" : ""}`}
            onClick={() => handleFAQClick(faq.question)}
          >
            <div className="flex justify-between items-center gap-1">
              <div className="faq-question-text">{faq.question}</div>
              {expandedFAQ === faq.question ? (
                <RemoveIcon className="expand-icon" />
              ) : (
                <AddIcon className="expand-icon" />
              )}
            </div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
